module.exports = __webpack_public_path__ + "static/media/nowhere-logo-2.8e063d6c.svg";